// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import './router/routeInterceptor'
import store from './store'
import Request from './request/index'
import Antd, { Icon } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/styles/reset.less' // global css
import '@/styles/ant.less' // global css
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import moment from 'moment'
import 'moment/locale/zh-cn'
import * as echarts from 'echarts'
import light from '@/styles/echartstheme/echarts_light.json'
import baseUrl from '../config/api.config'
import '@/styles/iconfont/iconfont.css'
import Kunlun from '@/utils/kunlun'
import 'qweather-icons/font/qweather-icons.css'
// import iconfont from '@/styles/iconfont/iconfont.js'

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2772162_kuwis31ajqn.js'
  // scriptUrl: iconfont
})

Vue.use(Kunlun)
/*
 * happy-scroll 的使用和参数：
 *  <happy-scroll resize smaller-move-v="start" :min-length-v="10"></happy-scroll>
  * */
Vue.use(HappyScroll)
Vue.use(Antd)
Vue.component('IconFont', IconFont)
Vue.prototype.$Request = Request

moment.locale('zh-cn')
Vue.prototype.$moment = moment
// Vue.prototype.$IOTURL = process.env.ENV_IOTURL
Vue.prototype.$echarts = echarts
echarts.registerTheme('light', light) // 注册自定义主题--白色背景下的主题

Vue.prototype.$BASE_URL = baseUrl.baseUrl // 访问地址前缀
Vue.prototype.$ENV_IOTURL = process.env.ENV_IOTURL // 访问地址前缀
Vue.config.productionTip = false

Vue.prototype.$setLoading = function (props) {
  if (typeof props === 'boolean') props = { spinning: props }
  if (Object.prototype.toString.call(props) !== '[object Object]') props = {}
  this.$app.loadingProps = {
    tip: '数据加载中，请稍等',
    ...props
  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js